import React from 'react'
import {Link} from 'react-router-dom'

import {issueMatchingObj, conIdMatchingObj} from '../helper'

function TableBodyRow({battery, chunk, index}) {

  return (
    
    <tr key={battery.id} className="App-table-row">
      <td className="App-table-link"><Link className="App-link " to={`${battery.id}`}>{index + chunk + 1} </Link> </td>
      <td className="App-table-link"><Link className="App-link btn" to={`${battery.id}`}>{battery.id} </Link> </td>
      <td>{battery.location ? battery.location : 'N/A'}</td>
      <td>{battery.voltage }</td>
      <td>{battery.capacity}</td>
      <td>{conIdMatchingObj[battery.connectionStatus]}</td>
      <td>{battery.lastConnectionTime}</td>
      <td>{battery.stateOfCharge ? battery.stateOfCharge : 'N/A'}</td>
      <td>{battery.stateOfHealth ? battery.stateOfHealth : 'N/A'}</td>
      <td>{battery.recentIssues[0] ? battery.recentIssues.map((issue, index )=> <p key={issue + index} style={{fontSize:'10pt', color : index % 2 === 0 ? 'black' : 'gray' }}>{issueMatchingObj[issue]}</p>) : 'N/A'}</td>
    </tr>
    
   

  )
}

export default TableBodyRow